import './src/styles/globals.scss';
import Provider from './src/utils/LanguageContext';

export const wrapRootElement = Provider;

export const shouldUpdateScroll = () => {
    return false
}
